module.exports = __webpack_public_path__ + "img/Penguin-fail.c9647420.png";